export const searchGames = (games, search) =>
  games?.filter(
    ({ name, regionId }) =>
      name.toLowerCase().includes(search.toLowerCase()) ||
      regionId?.some(({ id }) => id.toString() === search),
  );
